import { action } from './utils';

export const SET_HELP_DRAWER_OPEN = 'SET_HELP_DRAWER_OPEN';
export const SET_HELP_DRAWER_CLOSED = 'SET_HELP_DRAWER_CLOSED';

export const setDrawerOpen = () => action('SET_HELP_DRAWER_OPEN');

export const setDrawerClosed = () => action('SET_HELP_DRAWER_CLOSED');
